import { render, staticRenderFns } from "./Xero.vue?vue&type=template&id=4f254cd6"
import script from "./Xero.vue?vue&type=script&lang=js"
export * from "./Xero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports